/** @type {string} Unified auth route (login + sign-up tabs). */
export const CDS_FP_LOGIN_PATH = '/frequent-passenger/login';

/** @type {string} Query param for auth tab (`login` default, `signup`). */
export const CDS_FP_AUTH_TAB_QUERY = 'tab';

/** @type {string} Query param for sign-up sub-step (`check-email`, `activation`, `success`). */
export const CDS_FP_AUTH_STEP_QUERY = 'step';

/** @type {'login'} */
export const CDS_FP_AUTH_TAB_LOGIN = 'login';

/** @type {'signup'} */
export const CDS_FP_AUTH_TAB_SIGNUP = 'signup';

/** @type {string} DOM id for login auth tab control. */
export const CDS_FP_AUTH_TAB_LOGIN_ID = 'cds-fp-auth-tab-login';

/** @type {string} DOM id for sign-up auth tab control. */
export const CDS_FP_AUTH_TAB_SIGNUP_ID = 'cds-fp-auth-tab-signup';

/** @type {string} DOM id for login auth tab panel. */
export const CDS_FP_AUTH_PANEL_LOGIN_ID = 'cds-fp-auth-panel-login';

/** @type {string} DOM id for sign-up auth tab panel. */
export const CDS_FP_AUTH_PANEL_SIGNUP_ID = 'cds-fp-auth-panel-signup';

/** @type {string} Route for CDS Pasajero Frecuente account (Fase 4). */
export const CDS_FP_ACCOUNT_PATH = '/frequent-passenger';

/** @type {string} Password update route (session required, unlike the auth page). */
export const CDS_FP_PASSWORD_PATH = '/frequent-passenger/password';

/** @type {string[]} Document types accepted by CDS loyalty login API. */
export const CDS_FP_LOGIN_DOCUMENT_TYPES = ['DNI', 'CE', 'PAS'];

/** @type {'personal'} Enrollment wizard — step 1 (personal data). */
export const CDS_FP_ENROLLMENT_WIZARD_STEP_PERSONAL = 'personal';

/** @type {'identification'} Enrollment wizard — step 2 (identification). */
export const CDS_FP_ENROLLMENT_WIZARD_STEP_IDENTIFICATION = 'identification';

/** @type {Record<string, number>} Progress bar fill per enrollment wizard step. */
export const CDS_FP_ENROLLMENT_WIZARD_PROGRESS = {
  [CDS_FP_ENROLLMENT_WIZARD_STEP_PERSONAL]: 50,
  [CDS_FP_ENROLLMENT_WIZARD_STEP_IDENTIFICATION]: 100,
};

/** @type {Set<string>} Translation keys stored in Redux `error` (not raw API messages). */
export const CDS_FP_ERROR_KEYS = new Set([
  'generic_error',
  'login_error',
  'invalid_credentials',
  'enrollment_error',
  'activation_error',
  'session_expired',
  'logout_error',
  'password_update_error',
]);
